<script>
import Notification from '../../reUse/Notification.vue';
import NastavitveCurrent from "./Meni_nastavitve_current.vue";
import {config} from "@/config";
export default {
  components: {
    Notification,
    NastavitveCurrent,
  },
  emits: ['odjava'],
  data() {
    return {
      krogMinuta: '',
      text: '',
      types: '',
      ShowNoti: false,
      isSubmitting: false,
      userLvl: config.UserLVL
    }
  },
  mounted() {
    this.GetData();
  },
  methods: {
    GetData() {
      axios.get('./api/nastavitve/splosno/krogi/izpis/', {withCredentials: true}).then((response) => {
        this.krogMinuta = response.data.vrednost;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.sporocilo !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.sporocilo;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    Update() {
      var podatki = new URLSearchParams();
      podatki.append('nastavitev', 'solski_krogi');
      podatki.append('vrednost', this.krogMinuta);
      axios.post('./api/nastavitve/splosno/krogi/vnos/', podatki, {withCredentials: true}).then((response) => {
        this.text = response.data.sporocilo;
        this.types = 'Uspešno';
        this.ShowNoti = true;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.sporocilo !== undefined) {
          this.text = 'Napaka pri posodabljanju podatkov. ' + napaka.response.data.sporocilo;
        } else {
          this.text = 'Napaka pri posodabljanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
  }
  }
</script>
<template>
  <!-- 		<button class="p-2 btn-back" @click.prevent="$emit('back')"><i class="fas fa-arrow-left fa-2x"></i></button>
      <h5 class="d-flex justify-content-center text-white">Splošne nastavitve</h5> -->
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>Nazaj</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">Nastavitve letenja</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <div class="pregled-povrsin-container">
    <main class="main-content">
      <!-- VNOS ŠOLSKIH KROGOV-->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-stopwatch"></i>
          </div>
          <div class="section-title">
            <h3>Dolžina šolskega kroga</h3>
            <p>vnesena dolžina bo upoštevana pri vnosu šolskih krogov za razdelitev letov</p>
          </div>
        </div>
        <div class="section-content">
          <div class="form-grid">
            <div class="form-group">
              <label class="form-label">Dolžina šolskega kroga (v minutah)</label>
              <input type="number"
                     v-model="krogMinuta"
                     class="form-input"
                     step='1'
                     placeholder="90" />
            </div>
          </div>
        </div>
        <!-- Form Actions -->
        <div class="form-actions">
          <div class="action-buttons">
            <button type="button"
                    class="btn btn-primary"
                    @click.prevent="Update()"
                    :disabled="isSubmitting">
              <i class="fas fa-sync-alt" v-if="!isSubmitting"></i>
              <i class="fas fa-sync-alt fa-spin" v-if="isSubmitting"></i>
              <span v-if="isSubmitting">Posodabljam</span>
              <span v-else>Posodobi vnos</span>
            </button>
          </div>
        </div>
      </div>
      <br/>
      <!--         <div class="container p-2">
                  <div class="col-12">
                      <div class="container">
                          <div class="label-date p-2 col-6" for="krogMinuta">Dolžina šolskega kroga (v minutah)</div>
                          <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="krogMinuta" v-model="krogMinuta" required />
                      </div>
                  </div>
                  <div class="container p-2">
                      <button @click.prevent="Update()" class="btn btn-primary rounded-pill btn-add col-12">Posodobi vnos</button>
                    <Transition name="fade">
                        <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
                    </Transition>
                  </div>
              </div> -->
      <!-- NASTAVITVE CURRENT -->
      <nastavitve-current v-if="userLvl == 0" />
      <Transition name="fade">
        <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="OdgovoriDa()" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
      </Transition>
    </main>
  </div>
</template>